import { render } from "./SelectCurrency.vue?vue&type=template&id=0af937f2&scoped=true"
import script from "./SelectCurrency.vue?vue&type=script&lang=js"
export * from "./SelectCurrency.vue?vue&type=script&lang=js"

import "./SelectCurrency.vue?vue&type=style&index=0&id=0af937f2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0af937f2"]])

export default __exports__